if (!customElements.get('product-info-tabs')) {
  customElements.define(
    'product-info-tabs',
    class ProductInfoTabs extends HTMLElement {
      connectedCallback() {
        this.buttons = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));
        this.buttons.forEach((button) => {
          button.addEventListener('click', () => {
            if (button.disabled) return;
            this.select(button);
          });
        });
      }

      select(button) {
        const tab = button.dataset.tab;
        this.buttons.forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        this.panels.forEach((panel) => {
          const active = panel.dataset.tabPanel === tab;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      }
    }
  );
}
